import { styled } from 'next-yak'

export const Group = styled.div`
  display: flex;
  flex-direction: row;
`
